<template lang='pug'>
router-view
</template>

<style lang="scss">
  @use '~@printos/agnostic-styles/src/mixins' as *;
  @use '~@printos/agnostic-styles/src/button' as *;
  @use '~@printos/agnostic-styles/src/layout' as *;
  @use '~@printos/agnostic-styles/src/dialog' as *;
  @use '~@printos/agnostic-styles/src/forms' as *;

  body {
    display: flex;
    flex-direction: column;
    height: 100vh;
    /*font-family: HPSimplified, Roboto;*/
    font-size: 16px;
    margin: 0;
    overflow: hidden;
  }

  body[pos--theme=light] {
    color: #212121;
    background-color: #ffffff;
  }

  body[pos--theme=dark] {
    color: #ebebeb;
    background-color: #212121;
  }

  .app-container {
    display: flex;
    flex-direction: row;
    flex: 1;
    overflow: hidden;
    .app-view {
      flex:1;
      display: flex;
      flex-direction: column;
    }
  }
</style>

<script>
  import PrintOSService from "@/services/PrintOS.service";

  export default {
    components: {
    },
    setup() {
      const printOS = new PrintOSService();
      return { printOS };
    },
    data() {
      return {
        loading: true,
      };
    },
    mounted() {
      let promises = [];
      //this.printOS.ui.v1.startProgress();
      return Promise.all(promises).then(() => {
      })
        .finally(() => {
          //this.printOS.ui.v1.endProgress();
          this.loading = false;
        });
    },
    beforeMount() {
    }
  }
</script>
